import type { ReactNode } from 'react';
import { HeroUIProvider } from '@heroui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { queryClient } from '@/api/queryClient';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { UIProvider } from '@/contexts/UIContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { NotificationProvider } from '@/contexts/NotificationContext';

/**
 * The single nested provider tree. Order matters: Query + HeroUI outermost,
 * then Theme (sets the html class), then Auth + UI + Notifications app state,
 * then the Toaster.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <HeroUIProvider>
        <ThemeProvider>
          <AuthProvider>
            <UIProvider>
              <NotificationProvider>
                {children}
                <Toaster
                  position="top-right"
                  toastOptions={{
                    className: 'nh-toast',
                    style: {
                      background: 'rgb(var(--nh-surface-raised))',
                      color: 'rgb(var(--nh-fg))',
                      border: '1px solid rgb(var(--nh-border))',
                    },
                  }}
                />
              </NotificationProvider>
            </UIProvider>
          </AuthProvider>
        </ThemeProvider>
      </HeroUIProvider>
    </QueryClientProvider>
  );
}
